import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0d3b20f4&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Crumbs: require('/var/www/components/crumbs/crumbs.vue').default,CatalogUsed: require('/var/www/components/catalog/catalog-used.vue').default,SeoTextUsed: require('/var/www/components/seo-text/seo-text-used.vue').default})
